<template>
    <div>
        <v-toolbar flat color="transparent">
            <v-toolbar-title>
                Pedidos
            </v-toolbar-title>
            <a class="filter-button" @click="showFilters = !showFilters">Filtros <v-icon small>arrow_drop_down</v-icon></a>
            <v-spacer></v-spacer>
            <v-btn class="classic-add-button" v-if="credentials.OrdersCreate" color="primary" @click="goTo('Ordersform')">
                <v-icon dark>person_add</v-icon>Agregar
            </v-btn>
        </v-toolbar>
            <v-form v-if="showFilters">
                <v-container fluid>   
                    <h3>Filtros</h3>
                    <v-layout row wrap>
                    </v-layout>
                </v-container>
            </v-form>
        <br />
        <v-divider class="divider-container"></v-divider>
        <br />
        
        <v-data-table
            :headers="headers"
            :items="list"
            :loading="loading"
            class="classic-table"
        >
            <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props">
                <tr v-bind:class="{ itemToDelete: props.item.id == itemToDelete }">
                    <td class="text-xs-center">
                        <v-icon color="primary" v-if="credentials.OrdersRead" v-on:click.stop="goTo('Ordersdetail/' + props.item.id)">visibility</v-icon>
                        <v-icon color="primary" v-if="credentials.OrdersUpdate" v-on:click.stop="goTo('Ordersform/' + props.item.id)">edit</v-icon>
                        <v-icon color="error" v-if="credentials.OrdersDelete" v-on:click.stop="confirmDelete(props.item.id)">delete</v-icon>
                    </td>
                </tr>
            </template>
            <template slot="no-data">
                No hay registros para sus parámetros de búsqueda. Favor de intentar otra búsqueda o crear uno nuevo.
                
            </template>
        </v-data-table>
        <v-dialog v-model="deleteDialog" max-width="350">
            <v-card>
                <v-card-title class="headline">Confirmación</v-card-title>
                <v-card-text>¿Está seguro de querer borrar este registro?</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" flat @click="deleteDialog=false; itemToDelete = '';">Cancelar</v-btn>
                    <v-btn color="primary" flat @click="deleteDialog=false; deleteRegistry(itemToDelete)">Aceptar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>


<script>
    import { events, printList } from '../main';
    import _ from 'underscore';
    import moment from 'moment-timezone';

    export default {
        components: { 
        },
        data () {
            return {
                list: [],
                source: [],
                search: {},
                showFilters: false,
                headers: [
                    { text: 'Acciones', value: 'delete', align: 'center' },
                ],
                loading: true,
                deleteDialog: false,
                itemToDelete: '',
                credentials: JSON.parse(localStorage.getItem('userCredentials')),
            }
        },
        methods: {
            snackbar: function(message) {
                events.$emit('snackbar', message);            
            },
            confirmDelete: function(id) {
                this.itemToDelete = id;
                this.deleteDialog = true;
            },
            goTo(url) {
                var self = this;
                self.$router.push('/' + url);
            },
            getList: function() {
                this.$http.get('Orders')
                    .then(response => {
                        var list = response.body;
                        this.list = list;
                        this.source = list;
                        this.loading = false;
                    }, error => {
                        this.snackbar('Hubo un problema al obtener la lista');
                        console.error(error);
                    })
            },
            deleteRegistry(id) {
                this.showConfirm = false;
                this.$http.delete('Orders/' + id)
                    .then(response => {
                        this.itemToDelete = '';
                        this.getList();
                        this.snackbar('El registro ha sido eliminado con éxito');
                    }, error => {
                        this.itemToDelete = '';
                        this.snackbar('Hubo un problema al eliminar el registro');
                        console.error(error);
                    });
            },
            searchOnTable: function() {
                var self = this;
                this.list = _.filter(this.source, function(item) {
                    return 1 === 2
                });
            },
            clean(field) {
                this.search[field] = null;
                this.$refs[`${field}Menu`].save(this.search[field]);
            },
            searchByParams: function() {
                var queryString = Object.keys(this.search).filter(key => this.search[key] !== '').map(key => key + '=' + this.search[key]).join('&');
                this.$http.get(`Orders/search?${queryString}`)
                    .then(response => {
                        var list = response.body;
                        this.list = list;
                        this.source = list;
                        this.loading = false;
                    }, error => {
                        this.snackbar('Hubo un problema al obtener la lista');
                        console.error(error);
                    });
            },
        },
        mounted() {
            this.getList();
        },
        filters: {
            moment: function (date) {
                return moment(date).locale("es").format('LL');
            }
        },
        watch: {
            search: {
                handler(value) {
                    this.debouncedSearchFilter();
                },
                deep: true,
                immediate: false
            }
        },
        created: function() {
            this.debouncedSearchFilter = _.debounce(this.searchByParams, 500);
        },
    }
</script>